import { useAuth } from '../../contexts/AuthContext';
import { canEditRecord } from '../../lib/recordAccess';
import { useEffect, useState } from 'react';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { SaveOutlined } from '@mui/icons-material';
import { API } from '../../lib/api';

export default function OpportunityNotes({ project, setProject, setLogs, setFeedback }) {
    const { user } = useAuth();
    const canEdit = canEditRecord(user, project);
    const [notes, setNotes] = useState(project?.comments || '');
    const [saving, setSaving] = useState(false);
    useEffect(() => { setNotes(project?.comments || ''); }, [project?._id, project?.comments]);

    const save = async () => {
        setSaving(true);
        try {
            const response = await API.Opportunities.UpdateSingle(project._id, { comments: notes });
            if (response.status !== 200) throw new Error(response.data?.message || 'Unable to save notes.');
            setProject(previous => ({ ...previous, comments: notes }));
            setFeedback({ open: true, type: 'success', message: 'Opportunity notes saved.' });
            setLogs(await API.OpportunityLogs.FetchByOppId(project._id));
        } catch (error) {
            setFeedback({ open: true, type: 'error', message: error.message || 'Unable to save notes.' });
        } finally { setSaving(false); }
    };

    return <Box className="card" sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>Opportunity notes</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Keep project context, customer requests, and handoff details together. These notes are internal.
        </Typography>
        <TextField label="Notes" multiline minRows={7} fullWidth value={notes} disabled={!canEdit || saving}
            onChange={event => setNotes(event.target.value)} />
        <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
            <Button variant="contained" startIcon={<SaveOutlined />} onClick={save}
                disabled={saving || !project?._id || notes === (project?.comments || '')}>
                {saving ? 'Saving...' : 'Save notes'}
            </Button>
        </Stack>
    </Box>;
}
